module.exports = __webpack_public_path__ + "img/quartercar-logo-small.svg";